"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "val-della-torre": {
    "42877637": [{
      "hkey": "f9453be1",
      "slug": "brione",
      "name": "Brione",
      "primary": true,
      "skipSearch": false
    }],
    "trucco-di-brione": [{
      "hkey": "f9453be1",
      "slug": "brione",
      "name": "Brione",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "val-della-torre"
    }]
  }
};
exports["default"] = _default;